import { z } from 'zod';

/**
 * ATL-1477 — the client side of the backend's snapshot windows
 * (`apps/atlas-backend/src/common/utils/id-window.util.ts`).
 *
 * `GET /<list>/window?idFrom&idTo` returns the list rows whose primary key is in `[idFrom, idTo)` —
 * at most 200 — plus `total`, the exact number of rows that window holds, counted in the same SQL
 * statement. `rows.length === total` proves the window complete. Readers never call these routes
 * directly; `readWholeList` (apps/atlas/global/API/readWholeList.ts) does, splitting any window that
 * holds more than one response carries.
 */

/** Inclusive lower / exclusive upper bound of a window, as lowercase UUIDs; absent = unbounded. */
export interface IdWindowParams {
  idFrom?: string;
  idTo?: string;
}

export interface IdWindowPage<T> {
  total: number;
  rows: T[];
  idFrom: string | null;
  idTo: string | null;
}

export const idWindowPageSchema = <T extends z.ZodTypeAny>(row: T) =>
  z.object({
    total: z.number().int().nonnegative(),
    rows: z.array(row),
    idFrom: z.string().nullable(),
    idTo: z.string().nullable(),
  });
